module.exports = __webpack_public_path__ + "static/media/icon_85.dc06a25c.svg";